export class MsgRecipient {
  msgRecipientId: number;
  firstName: string;
  lastName: string;
  email: string;
  mobileNum: string;
  mobileCountryCode: string;
  emailRecipientType: string;
  msgId: any;
  openedCount?: number;
  openedDate?: any;
  bouncedCount?: number;
  bouncedDate?: any;
  deliveredDate?: any;
  deferredDate?: any;
  deferredCount?: number;
  clickedCount?: number;
  clickedDate?: any;
  droppedDate?: any;
  unsubscribedDate?: any;
}
